import balanceCmsHtml from './balanceCmsHtml';

// Quick test to skip balancing for strings that obviously aren't HTML — keeps
// the recursive walk cheap when a config has lots of plain-text fields.
const looksLikeHtml = s => /<\/?[a-z][^>]*>/i.test(s);

// Recursively walk a parsed CMS-config value and balance any string that
// contains HTML markup. Non-HTML strings, numbers, booleans, null, and
// undefined are returned unchanged.
const balanceCmsConfig = value => {
  if (typeof value === 'string') {
    return looksLikeHtml(value) ? balanceCmsHtml(value) : value;
  }
  if (Array.isArray(value)) {
    return value.map(balanceCmsConfig);
  }
  if (value && typeof value === 'object') {
    const out = {};
    for (const key of Object.keys(value)) {
      out[key] = balanceCmsConfig(value[key]);
    }
    return out;
  }
  return value;
};

export default balanceCmsConfig;
